module.exports = __webpack_public_path__ + "static/media/44452920_2199893750085804_940726338950529024_o.006ffb13.jpg";